import striptags from 'striptags';

/**
 * Returns true if the string has no visible content after stripping HTML tags.
 * For example, "<p></p>" is considered empty.
 */
const isEmptyBlockContent = (str: string): boolean => striptags(str || '').trim().length === 0;

export default isEmptyBlockContent;
